const COLORES_DASHBOARD = [
  '#A259B7', // Morado
  '#8AD26F', // Verde claro
  '#184363', // Azul noche
  '#FF9F43', // Naranja
  '#FF5681', // Rosa
  '#205984', // Azul profundo
  '#FFB6D5', // Rosa claro
  '#0275AA', // Azul
  '#FF6B6B', // Coral
  '#60AED3', // Azul celeste
  '#4CBF9F', // Verde menta
  '#2067B0', // Azul medio
  '#F5C74F', // Amarillo
  '#10A7A7', // Turquesa
]

export {
  COLORES_DASHBOARD
}
